var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.usuarioCarregado === true)?_c('router-view'):_c('div',{staticClass:"d-flex vh-100"},[_c('load-placeholder',{attrs:{"loading":true}})],1),_c('DialogRoot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }